import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AbstractService } from "@gipi-pages/abstract/services/abstract.service";
import { ClientClassificationModel } from "../models/client-classification.model";
import { ClientClassificationFilterDTO } from "../models/dto/client-classification-filter.dto";

@Injectable({ providedIn: 'root' })
export class ClientClassificationService extends AbstractService<ClientClassificationModel, ClientClassificationFilterDTO> {

    constructor(protected httpClient: HttpClient) {
        super('APOIO', 'client-classification', httpClient);
    }

}
